import axios from 'axios';
import Spinners from 'components/Common/Spinner';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, Col, FormGroup, Input, Row } from 'reactstrap';
import { changeFeedBackListStatus, getFeedbackList, getParentsToStaffFeddbacks } from 'store/actions';

const ParentsToTeacherFeedback = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [sortedFeedbackList, setSortedFeedbackList] = useState([]);

    const [searchedArray, setSearchedArray] = useState([])
    const [searchString, setSearchString] = useState("")
    const [allClassDiv, setAllClassDiv] = useState([])
    const [selectedClassDiv, setSelectedClassDiv] = useState(null)

    const { feedbackType,
        feedbackListStatus,
        Loading,
        feedbacklist
    } = useSelector(state => state.FeedBackReducer)

    const HandleFeedBackListStatus = (status) => dispatch(changeFeedBackListStatus(status));

    const renderDate = (timestamp) => moment.utc(timestamp).format("DD/MM/YYYY"); // Ensure no timezone shift


    const redirectToChats = (feedback) => {
        //    console.log(`Navigating to: ${location.pathname}/chats`);
        navigate(`${location.pathname}/chats`, {
            state: {
                conversationID: feedback.conversation_id,
                chatSubject: feedback.subject,
                msg_to: feedback?.msg_to || null,
                from_name: feedback?.from_name || null,
                from_id: feedback?.from_id || null, // for ADMIN to view conversation of parents to teachers
                student_name: feedback?.student_name || null,
                staff_name: feedback?.staff_name || null,
                feedbackType: "Parents to Teacher",
                div_name: feedback.div_name,
            },
        });
    };

    useEffect(() => {
        let newList = [];

        const sortByTimestampDesc = (array) => {
            return array.sort((a, b) => new Date(b.latest_msg_updatedDate) - new Date(a.latest_msg_updatedDate));
        };


        if (feedbackListStatus === 0) {
            for (let i = 0; i < feedbacklist?.length; i++) {
                if (feedbacklist[i].new_or_old_status === "New") {
                    newList.push(feedbacklist[i])
                }
            }


        } else if (feedbackListStatus === 1) {
            for (let i = 0; i < feedbacklist?.length; i++) {
                if (feedbacklist[i].new_or_old_status === "Old") {
                    newList.push(feedbacklist[i])
                }
            }
        } else {
            newList = feedbacklist ? feedbacklist : []
        }

        setSortedFeedbackList(sortByTimestampDesc(newList))

    }, [feedbacklist, feedbackListStatus])


    useEffect(() => {
        const result = [];

        for (let i = 0; i < sortedFeedbackList.length; i++) {
            const entry = sortedFeedbackList[i];

            const searchFields = [
                feedbackType === 0 ? entry.from_name :
                    entry.staff_name,
                entry.div_name,
                entry.student_name
            ];

            let matchFound = searchFields.some(field => {
                if (!field) return false;
                for (let j = 0; j < searchString.length; j++) {
                    if (j >= field.length || field[j].toLowerCase() !== searchString[j].toLowerCase()) {
                        return false;
                    }
                }
                return true;
            });

            if (matchFound) result.push(entry);
        }
        setSearchedArray(result);

    }, [searchString, sortedFeedbackList, feedbackType]);

    const getClassDivision = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_LIVE_API_URL}/api/tscommon/all-new-div`,
                {
                    sid: localStorage.getItem("sid"),
                }
            )
            setAllClassDiv(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getClassDivision()
    }, [])


    // useEffect(() => {
    //     dispatch(getFeedbackList())
    // }, [feedbackType])

    useEffect(() => {
        dispatch(getParentsToStaffFeddbacks({
            class_div_id:selectedClassDiv,
            search_string: searchString}))
    }, [feedbackType, selectedClassDiv, searchString])

    return (
        <div>
            <div className="d-flex mb-2 mx-0 border border-2 p-1 rounded-3 overflow-auto">

                <div
                    className={`border border-2 p-2 rounded-5 
                    ${feedbackListStatus === 0 ? 'bg-primary text-white' : ''}  text-nowrap `}
                    onClick={() => HandleFeedBackListStatus(0)}
                    style={{ cursor: 'pointer' }}
                >
                    New
                </div>

                <div
                    className={`border border-2 p-2 rounded-5 text-nowrap 
                    ${feedbackListStatus === 1 ? 'bg-primary text-white' : ''}`}
                    onClick={() => HandleFeedBackListStatus(1)}
                    style={{ cursor: 'pointer' }}
                >
                    Replied
                </div>

            </div>
            <Row>
                <Col md={6}>
                    <Input
                        placeholder={"Search By Teacher Name, Student Name and Class"}
                        onChange={(e) => setSearchString(e.target.value)} />
                </Col>

                <Col md={6}>
                    <FormGroup>
                        <Input
                            name='classdiv_id'
                            id='classdiv_id'
                            type='select'
                            placeholder='SELECT CLASS AND DIVISION'
                            onChange={(e) => setSelectedClassDiv(e.target.value)}


                        >
                            <option value={""}>SELECT CLASS AND DIVISION</option>
                            {allClassDiv.map((data, index) => (<option key={index} value={data.id}>{data.div_name}</option>))}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>


            {
                Loading ? <Spinners /> :
                    <Card className="p-2">
                        <CardBody className="p-1">
                            <div className="">
                                {sortedFeedbackList.length > 0 ? (
                                    sortedFeedbackList.map((feedback, index) => (
                                        <div
                                            key={index}
                                            onClick={() => redirectToChats(feedback)}
                                            className="chat-contact-link"
                                        >
                                            <Row className="chat-contact">
                                                <Col
                                                    xs={12}
                                                    className={`d-flex flex-column justify-content-center ${feedback.read_status === 'Unread' ? 'fw-bold' : ''}`}
                                                >
                                                    <div className="w-100">
                                                        <div className="d-flex justify-content-between">
                                                            <p
                                                                style={{ fontSize: "1.1rem" }}
                                                                className="p-0 m-0 chat-contact-subject"
                                                            >
                                                                {feedback.subject}
                                                            </p>
                                                            <p className="p-0 m-0 text-secondary chat-contact-date">
                                                                {renderDate(feedback.createdDate)}
                                                            </p>
                                                        </div>
                                                        {
                                                            feedbackType === 1 ?

                                                                <div className="">
                                                                    <p className="p-0 m-0 text-secondary chat-contact-to">
                                                                        From: {feedback.student_name} - {feedback.div_name}
                                                                    </p>

                                                                    <p className="p-0 m-0 text-secondary chat-contact-to">
                                                                        To: {feedback.staff_name}
                                                                    </p>
                                                                </div>
                                                                :
                                                                <div className="">
                                                                    <p className="p-0 m-0 text-secondary chat-contact-to">
                                                                        {localStorage.getItem("group_id") == 2 //Group ID 2 is for student login. Here showing message to staff or admin to student.
                                                                            ? `To: ${feedback.msg_to}` // Admin / Staff
                                                                            : `From: ${feedback.from_name} - ${feedback.div_name}` // This is for teacher and admin login where we showing who created feedback.
                                                                        }
                                                                    </p>
                                                                </div>
                                                        }

                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))
                                ) : <p className="text-center m-0">There are no feedback messages present</p>}
                            </div>
                        </CardBody>
                    </Card>
            }
        </div>
    )
}

export default ParentsToTeacherFeedback